import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@unite-us/ui';
import ToolTip from 'src/common/ToolTip';
import { usePopulate } from 'src/api/APIHooks';

const invoiceStatusProps = {
  // CBO Admin
  submitted_contracted_service_note: {
    className: 'text-green',
    label: 'Submitted',
  },
  rejected_by_cbo_admin: {
    className: 'text-red',
    label: 'Rejected by CBO Admin',
  },

  // Network Lead
  submitted_to_network_lead: {
    className: 'text-green',
    label: 'Submitted to Network Lead',
  },
  rejected_by_network_lead: {
    className: 'text-red',
    label: 'Rejected by Network Lead',
  },

  // Payer
  submitted_to_payer: {
    className: 'text-green',
    label: 'Submitted to Payer',
  },
  transmitted_to_payer: {
    className: 'text-green',
    label: 'Transmitted to Payer',
  },
  accepted_by_payer: {
    className: 'text-green',
    label: 'Accepted by Payer',
  },
  rejected_by_payer: {
    className: 'text-red',
    label: 'Rejected by Payer',
  },
  paid: {
    className: 'text-green',
    label: 'Paid',
  },
};

const InvoiceStatus = ({ invoice }) => {
  const statusProps = invoiceStatusProps[invoice?.invoice_status];

  if (!statusProps) {
    return null;
  }

  const rejectionReason = invoice.invoice_rejection_reason;
  usePopulate('invoice_rejection_reason', 'invoice_rejection_reason', invoice, {
    queryConfig:
      { placeholderData: undefined, enabled: !!rejectionReason },
  });

  const RejectionReasonTooltipContent = () => (
    <div className="max-w-xs break-words">
      <table className="w-auto">
        <tbody>
          {invoice.invoice_rejection_reason && (
            <tr className="align-top">
              <td className="w-32 font-heavy-font text-text-blue leading-5 pr-4">
                Rejection Reason:
              </td>
              <td className="text-text-blue">
                {invoice.invoice_rejection_reason.display_name}
              </td>
            </tr>
          )}
          {invoice.rejection_note && (
            <tr className="align-top">
              <td className="w-32 font-heavy-font text-text-blue leading-5 pr-4">
                Note:
              </td>
              <td className="text-text-blue whitespace-pre-wrap break-words">
                {invoice.rejection_note}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );

  return (
    <div className="flex">
      <Icon
        className={`${statusProps.className} fill-current pt-px mr-1`}
        icon="IconCircle"
        size={24}
      />
      <span data-testid="ps-invoice-status" className="text-text-blue whitespace-nowrap">
        {statusProps.label}
      </span>
      {rejectionReason && (
      <ToolTip
        tooltipElementAs="span"
        enableHover
        buttonComponentContent={() => (
          <Icon
            icon="IconInfoCircle"
            size={14}
            color="#182A44"
            className="cursor-pointer ml-1"
          />
        )}
        panelComponentContent={() => (<RejectionReasonTooltipContent />)}
        panelClassName="bg-white border border-dark-border-blue border-solid rounded-md shadow-lg leading-normal p-8"
        placement="bottom"
      />
    )}
    </div>
  );
};

InvoiceStatus.propTypes = {
  invoice: PropTypes.shape({
    invoice_status: PropTypes.string.isRequired,
    invoice_rejection_reason: PropTypes.object,
    rejection_reason: PropTypes.object,
    rejection_note: PropTypes.string,
  }).isRequired,
};

export default InvoiceStatus;
